export default "__VITE_ASSET__DsyFv5u2__"